<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات مراحل آزمون مهارت پاسخ داده شده</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_AzmoonMaharat()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>کد آزمون</th>
              <th>عنوان آزمون</th>
              <th>عنوان مرحله</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_AzmoonMaharat
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_AzmoonMaharat|filter:Filter_title:'title').length
                      }
            ">
              <td>{{DataList_AzmoonMaharat.indexOf(item)+1}}</td>
              <td>{{item.customname}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.title2}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item" (click)="openModalFile(templateFile,item)"><i class="fa fa-file"></i> فایل </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left">فایل های مراحل 
      <b>'{{Data_Seleted_Delete.title2}}'</b>
      مشتری 
      <b>'{{Data_Seleted_Delete.customname}}' </b>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_File.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>عنوان</th>
            <th>فایل</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Seleted_Delete.file ">
            <td>{{Data_Seleted_Delete.file.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a *ngIf="item.templateSrc" class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                مشاهده فایل
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>
    <br/>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> توضیح </label>
        <input [(ngModel)]="Filter_dsc" name="Filter_dsc" type="text" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="SubmitSignInCustomerConfirm(1)">تایید</button>
    <button type="button" [disabled]="!Filter_dsc" class="btn btn-danger" (click)="SubmitSignInCustomerConfirm(-1)">عدم تایید</button>
    <button type="button" class="btn btn-warning" (click)="modalRef_File.hide()">بستن</button>
  </div>
</ng-template>